<template>
    <div>
        <div class="page-header card">
            <div class="row align-items-end">
                <div class="col-lg-12">
                    <under-bar-name title="Manuálne priradenie faktúry" :margin="false"></under-bar-name>
                </div>
            </div>
        </div>

        <div class="pcoded-inner-content">
            <div class="main-body">
                <div class="page-wrapper">
                    <div class="page-body">

                        <!-- Invoice tools nav -->
                        <div class="row mb-4">
                            <div class="col-md-4">
                                <div class="card h-100" style="border: 2px solid #4a90d9">
                                    <div class="card-block p-3 d-flex flex-column justify-content-center align-items-center text-center" style="min-height: 90px">
                                        <strong style="font-size: 14px; color: #4a90d9">Manuálne priradenie</strong>
                                        <small class="text-muted mt-1">Aktuálna stránka</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <a href="/admin/admin_page/missing-invoices" class="text-decoration-none">
                                    <div class="card h-100" style="cursor: pointer; transition: border-color .2s" onmouseover="this.style.borderColor='#e85d4a'" onmouseout="this.style.borderColor=''">
                                        <div class="card-block p-3 d-flex flex-column justify-content-center align-items-center text-center" style="min-height: 90px">
                                            <strong style="font-size: 14px">Chýbajúce faktúry</strong>
                                            <small class="text-muted mt-1">Porovnanie Stripe vs DB</small>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-md-4">
                                <div class="card h-100 invoice-gen-card" style="position: relative">
                                    <button class="zip-refresh" @click="refreshZip" title="Pregenerovať ZIP (vymaže cache)">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                                    </button>
                                    <div class="card-block p-3 d-flex flex-column justify-content-between" style="min-height: 90px">
                                        <strong style="font-size: 12px; text-transform: uppercase; letter-spacing: .06em; color: #27ae60">Generovať ZIP faktúr</strong>
                                        <div class="d-flex align-items-center justify-content-between mt-2">
                                            <button class="month-arrow" @click="prevMonth" title="Predchádzajúci mesiac">&#8249;</button>
                                            <div class="text-center" style="flex: 1">
                                                <span class="month-label">{{ selectedMonthName }}</span>
                                                <div v-if="selectedYear !== currentYear" class="year-label">{{ selectedYear }}</div>
                                            </div>
                                            <button class="month-arrow" @click="nextMonth" :disabled="isAtMaxMonth" :class="{ disabled: isAtMaxMonth }" title="Nasledujúci mesiac">&#8250;</button>
                                        </div>
                                        <div class="zip-status mt-2" v-if="monthReportLoading">kontrolujem …</div>
                                        <div v-else-if="monthReport" class="zip-status mt-2"
                                             :class="monthReport.complete ? 'zip-ok' : 'zip-warn'">
                                            <strong>{{ monthReport.included }}/{{ monthReport.expected }}</strong>
                                            <span v-if="monthReport.complete">&#10003; pripravené</span>
                                            <span v-else :title="missingNumbers">
                                                &middot; {{ monthReport.missing.length }} sa dotiahne pri exporte
                                            </span>
                                        </div>

                                        <a :href="generateUrl" target="_blank" class="btn-generate mt-2">
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right:5px;vertical-align:middle"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                            Stiahnuť ZIP
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Form card -->
                        <div class="card mb-4">
                            <div class="card-block p-4">
                                <h5 class="mb-4" style="font-weight: 600">Vytvoriť / priradiť faktúru</h5>

                                <div class="row">
                                    <!-- User search -->
                                    <div class="col-md-5 mb-3">
                                        <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 mb-1">
                                            Používateľ *
                                        </label>
                                        <div style="position: relative">
                                            <div v-if="selectedUser" class="form-control d-flex align-items-center justify-content-between" style="background: #f8f9fa">
                                                <span>{{ selectedUser.label }}</span>
                                                <span @click="clearUser" style="cursor: pointer; color: #9598A7; font-size: 18px; line-height: 1">&times;</span>
                                            </div>
                                            <input
                                                v-else
                                                v-model="userSearch"
                                                @input="onUserSearchInput"
                                                type="text"
                                                class="form-control"
                                                placeholder="Hľadaj podľa emailu alebo mena..."
                                                autocomplete="off"
                                            />
                                            <div
                                                v-if="!selectedUser && userItems.length > 0"
                                                class="card"
                                                style="position: absolute; z-index: 100; width: 100%; max-height: 220px; overflow-y: auto; top: 100%; left: 0; margin-top: 2px"
                                            >
                                                <div
                                                    v-for="user in userItems"
                                                    :key="user.id"
                                                    @click="selectUser(user)"
                                                    class="px-3 py-2"
                                                    style="cursor: pointer; border-bottom: 1px solid #f0f0f0; font-size: 13px"
                                                    @mouseenter="$event.currentTarget.style.background='#f8f9fa'"
                                                    @mouseleave="$event.currentTarget.style.background=''"
                                                >
                                                    {{ user.label }}
                                                </div>
                                            </div>
                                            <div
                                                v-if="!selectedUser && usersLoading"
                                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #9598A7; font-size: 12px"
                                            >
                                                ...
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Stripe Invoice ID -->
                                    <div class="col-md-4 mb-3">
                                        <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 mb-1">
                                            Stripe Invoice ID *
                                        </label>
                                        <input
                                            v-model="stripeInvoiceId"
                                            type="text"
                                            class="form-control"
                                            placeholder="in_1ABC..."
                                        />
                                    </div>

                                    <!-- Date -->
                                    <div class="col-md-3 mb-3">
                                        <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 mb-1">
                                            Dátum faktúry
                                        </label>
                                        <input
                                            v-model="invoiceDate"
                                            type="date"
                                            class="form-control"
                                        />
                                        <small class="text-muted">Predvolene: dnes</small>
                                    </div>
                                </div>

                                <div class="d-flex align-items-center mt-2" style="gap: 16px; flex-wrap: wrap">
                                    <button
                                        @click="submit"
                                        :disabled="submitting"
                                        class="btn btn-primary px-4"
                                        style="height: 40px; min-width: 160px"
                                    >
                                        <span v-if="submitting">Spracúva sa...</span>
                                        <span v-else>Vytvoriť faktúru</span>
                                    </button>

                                    <div v-if="result" :class="result.success ? 'alert-success' : 'alert-danger'" class="alert mb-0 py-2 px-3" style="font-size: 13px">
                                        {{ result.message }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Recent invoices -->
                        <div class="card">
                            <div class="card-block">
                                <div class="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
                                    <h5 style="font-weight: 600; margin: 0">Posledné faktúry</h5>
                                    <button @click="loadRecentInvoices" class="btn btn-sm btn-outline-secondary">
                                        Obnoviť
                                    </button>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-hover" style="margin-bottom: 0">
                                        <thead>
                                            <tr>
                                                <th>Číslo faktúry</th>
                                                <th>Stripe ID</th>
                                                <th>Používateľ</th>
                                                <th>Meno</th>
                                                <th>Suma</th>
                                                <th>Stav</th>
                                                <th>Dátum</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="invoicesLoading">
                                                <td colspan="7" class="text-center text-muted py-4">Načítava sa...</td>
                                            </tr>
                                            <tr v-else-if="recentInvoices.length === 0">
                                                <td colspan="7" class="text-center text-muted py-4">Žiadne faktúry</td>
                                            </tr>
                                            <tr v-for="inv in recentInvoices" :key="inv.id">
                                                <td><h6>{{ inv.invoice_number || '-' }}</h6></td>
                                                <td><code style="font-size: 11px">{{ inv.invoice_id }}</code></td>
                                                <td><h6>{{ inv.user_email || '-' }}</h6></td>
                                                <td><h6>{{ inv.user_name || '-' }}</h6></td>
                                                <td><h6>{{ inv.price ? inv.price + ' €' : '-' }}</h6></td>
                                                <td><h6>{{ inv.status }}</h6></td>
                                                <td><h6>{{ formatDate(inv.created_at) }}</h6></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        const now = new Date()
        const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        return {
            selectedUser: null,
            userSearch: '',
            userItems: [],
            usersLoading: false,
            userSearchTimeout: null,
            stripeInvoiceId: '',
            invoiceDate: now.toISOString().substring(0, 10),
            submitting: false,
            result: null,
            recentInvoices: [],
            invoicesLoading: false,
            selectedMonth: lastMonth.getMonth() + 1,
            selectedYear: lastMonth.getFullYear(),
            currentYear: now.getFullYear(),
            currentMonth: now.getMonth() + 1,
            monthReport: null,
            monthReportLoading: false,
        }
    },
    computed: {
        monthNames() {
            return ['Január','Február','Marec','Apríl','Máj','Jún','Júl','August','September','Október','November','December']
        },
        selectedMonthName() {
            return this.monthNames[this.selectedMonth - 1]
        },
        isAtMaxMonth() {
            const maxYear = this.currentMonth === 1 ? this.currentYear - 1 : this.currentYear
            const maxMonth = this.currentMonth === 1 ? 12 : this.currentMonth - 1
            return this.selectedYear === maxYear && this.selectedMonth === maxMonth
        },
        generateUrl() {
            return `/stripe/invoices/generate?year=${this.selectedYear}&month=${this.selectedMonth}`
        },
        missingNumbers() {
            if (!this.monthReport || !this.monthReport.missing) return ''
            return this.monthReport.missing.map(m => m.number || m.invoice_id).join(', ')
        },
    },
    watch: {
        selectedMonth() { this.loadMonthReport() },
        selectedYear() { this.loadMonthReport() },
    },
    mounted() {
        this.loadRecentInvoices()
        this.loadMonthReport()
    },
    methods: {
        prevMonth() {
            if (this.selectedMonth === 1) {
                this.selectedMonth = 12
                this.selectedYear -= 1
            } else {
                this.selectedMonth -= 1
            }
        },
        refreshZip() {
            window.open(`${this.generateUrl}&refresh=1`, '_blank')
        },
        loadMonthReport() {
            // Read-only kontrola úplnosti oproti Stripe. Nič nezapisuje.
            this.monthReportLoading = true
            this.monthReport = null
            const year = this.selectedYear
            const month = this.selectedMonth
            axios.get('/api/admin/invoices/month-report', { params: { year, month } })
                .then(res => {
                    // Ignoruj odpoveď, ak medzitým používateľ prepol mesiac.
                    if (year !== this.selectedYear || month !== this.selectedMonth) return
                    this.monthReport = res.data
                })
                .catch(() => { this.monthReport = null })
                .finally(() => {
                    if (year === this.selectedYear && month === this.selectedMonth) {
                        this.monthReportLoading = false
                    }
                })
        },
        nextMonth() {
            if (this.isAtMaxMonth) return
            if (this.selectedMonth === 12) {
                this.selectedMonth = 1
                this.selectedYear += 1
            } else {
                this.selectedMonth += 1
            }
        },
        onUserSearchInput() {
            clearTimeout(this.userSearchTimeout)
            if (!this.userSearch || this.userSearch.length < 2) {
                this.userItems = []
                return
            }
            this.userSearchTimeout = setTimeout(() => this.searchUsers(this.userSearch), 300)
        },
        searchUsers(search) {
            this.usersLoading = true
            axios.get(`/api/users/bySearch/${encodeURIComponent(search)}/null`)
                .then(response => {
                    this.userItems = (response.data || []).slice(0, 10).map(u => ({
                        id: u.id,
                        label: u.meno ? `${u.email} – ${u.meno} ${u.priezvisko || ''}`.trim() : u.email,
                        email: u.email,
                    }))
                })
                .finally(() => { this.usersLoading = false })
        },
        selectUser(user) {
            this.selectedUser = user
            this.userItems = []
            this.userSearch = ''
        },
        clearUser() {
            this.selectedUser = null
            this.userItems = []
            this.userSearch = ''
        },
        submit() {
            if (!this.selectedUser) {
                this.result = { success: false, message: 'Vyberte používateľa.' }
                return
            }
            if (!this.stripeInvoiceId || !this.stripeInvoiceId.trim().startsWith('in_')) {
                this.result = { success: false, message: 'Zadajte platné Stripe Invoice ID (začína in_).' }
                return
            }
            this.submitting = true
            this.result = null
            axios.post('/api/admin/invoice/create', {
                user_id: this.selectedUser.id,
                stripe_invoice_id: this.stripeInvoiceId.trim(),
                date: this.invoiceDate || null,
            })
                .then(response => {
                    const num = response.data.invoice?.invoice_number || this.stripeInvoiceId
                    this.result = { success: true, message: `Faktúra úspešne vytvorená: ${num}` }
                    this.stripeInvoiceId = ''
                    this.loadRecentInvoices()
                })
                .catch(error => {
                    const msg = error.response?.data?.message
                        || Object.values(error.response?.data?.errors || {}).flat().join(' ')
                        || 'Nastala chyba'
                    this.result = { success: false, message: typeof msg === 'string' ? msg : 'Nastala chyba' }
                })
                .finally(() => { this.submitting = false })
        },
        loadRecentInvoices() {
            this.invoicesLoading = true
            axios.get('/api/admin/invoices/recent')
                .then(response => { this.recentInvoices = response.data })
                .finally(() => { this.invoicesLoading = false })
        },
        formatDate(dateStr) {
            if (!dateStr) return '-'
            return new Date(dateStr).toLocaleDateString('sk-SK')
        },
    },
}
</script>

<style scoped>
.invoice-gen-card {
    border: 1px solid #e8f5e9;
    background: linear-gradient(135deg, #f9fffe 0%, #f0fdf4 100%);
    transition: box-shadow .2s, border-color .2s;
}
.invoice-gen-card:hover {
    box-shadow: 0 4px 16px rgba(39,174,96,.12);
    border-color: #a8e6c1;
}
.zip-refresh {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    background: #fff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #27ae60;
    cursor: pointer;
    transition: background .15s, border-color .15s, color .15s;
}
.zip-refresh:hover {
    background: #27ae60;
    border-color: #27ae60;
    color: #fff;
}
.month-arrow {
    background: none;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    width: 28px;
    height: 28px;
    font-size: 20px;
    line-height: 1;
    color: #555;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background .15s, border-color .15s, color .15s;
}
.month-arrow:hover:not(.disabled) {
    background: #27ae60;
    border-color: #27ae60;
    color: #fff;
}
.month-arrow.disabled,
.month-arrow:disabled {
    opacity: .35;
    cursor: default;
}
.month-label {
    font-size: 15px;
    font-weight: 700;
    color: #1a2e1a;
    letter-spacing: .01em;
}
.year-label {
    font-size: 11px;
    color: #888;
    margin-top: 1px;
    font-weight: 500;
}
.btn-generate {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #27ae60;
    color: #fff;
    border-radius: 6px;
    padding: 7px 14px;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    letter-spacing: .03em;
    transition: background .15s, box-shadow .15s;
    box-shadow: 0 1px 4px rgba(39,174,96,.25);
}
.btn-generate:hover {
    background: #219150;
    color: #fff;
    text-decoration: none;
    box-shadow: 0 3px 10px rgba(39,174,96,.3);
}

.zip-status {
    font-size: 11px;
    text-align: center;
    line-height: 1.3;
}
.zip-status.zip-ok { color: #27ae60; }
.zip-status.zip-warn { color: #c98a00; cursor: help; }
</style>
